import { ITableColumn } from "@interfaces/common.interfaces";

const saveBlob = (blob: Blob, filename: string): void => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};

export function downloadAsJson(
    columns: Array<ITableColumn<any>>,
    items: ReadonlyArray<any>,
    filenamePrefix: string,
): void {
    const exportable = columns.filter(c => c.showInExport !== false);

    const rows = items.map(item => {
        const obj: Record<string, unknown> = {};
        for (const col of exportable) {
            const raw = (item as any)[col.key];
            if (raw === undefined) continue;
            obj[col.key] = raw;
        }
        return obj;
    });

    const content = JSON.stringify(rows, null, 2);
    const blob = new Blob([content], { type: "application/json;charset=utf-8" });
    saveBlob(blob, `${filenamePrefix}.json`);
}
